import { ObservableFromFetch } from "../ObservableFromFetch"

interface ImageRequest {
  TestImageID: number
  TestDetailID: string
  TestDetailClinicalID: string
  IsMarketPlace: boolean
  TestDescription: string
}

export interface ImageData {
  Base64String: Base64String[]
  ImageType: string
  ExceptionMessage?: string
}

export interface Base64String {
  Base64Strings: string
  ImageType: string
  Title: string
}

export enum TestReleaseStatusID {
  PoctComplete = 5,
  PoctCompleteReleased = 6,
  LaboratoryTestingComplete = 8,
  LaboratoryTestingCompleteReleased = 9,
  MroReviewComplete = 11,
  MroReviewCompleteReleased = 12
}

export default function ImageGet(request: ImageRequest) {
  const requestBody: string = JSON.stringify(request)
  return ObservableFromFetch<ImageData>("CCFImage/GetCCFImage", requestBody)
}

export function GenerateMROReport(testDetailID: string) {
  const requestBody: string = JSON.stringify({
    ReportKey: 1,
    PrintRecords: testDetailID
  })

  return ObservableFromFetch<string>("Report/EventsReport", requestBody)
}

export function GetMROLetter(testDetailID: string) {
  const requestBody: string = JSON.stringify({
    PrintRecords: testDetailID
  })

  return ObservableFromFetch<string>("WorkforceReport/MroLetter", requestBody)
}
